var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import classnames from 'classnames';
import Base from '../Base/Base';
import './RadialProgress.css';
class RadialProgress extends Component {
  render() {
    const _a = this.props,
      {
        children,
        className,
        diameter,
        size,
        sizeRem
      } = _a,
      rest = __rest(_a, ["children", "className", "diameter", "size", "sizeRem"]);
    const style = {};
    const classes = classnames(className, 'ax-radial-progress', {
      [`ax-radial-progress--${size}`]: size
    });
    if (sizeRem) {
      style.width = sizeRem;
      style.height = sizeRem;
    }
    return _jsx(Base, Object.assign({}, rest, {
      Component: "svg",
      className: classes,
      style: style,
      viewBox: `0 0 ${diameter} ${diameter}`,
      children: _jsx("g", {
        transform: `translate(${diameter / 2}, ${diameter / 2}) rotate(-90)`,
        children: children
      })
    }));
  }
}
export default RadialProgress;